import { ActionTree, GetterTree, MutationTree, Module } from 'vuex'
import { IStoreRootState } from '@/store'
import { Getters } from '@/store/getters'
import { Actions } from '@/store/actions'

type AlertColor = 'success' | 'error' | 'warning' | null

type Alert = {
  text: string | null
  color: AlertColor
}

export interface IAlertModuleState {
  visible: boolean;
  alert: Alert;
}

class AlertState implements IAlertModuleState {
  visible: boolean = false
  alert: Alert = {
    text: null,
    color: null
  }
}

// initial state
const state = new AlertState()

// getters
const getters: GetterTree<IAlertModuleState, IStoreRootState> = {
  [Getters.ALERT]: (state: IAlertModuleState): Alert => state.alert,
  [Getters.ALERT_VISIBLE]: (state: IAlertModuleState): boolean => state.visible
}

const AlertMutationsNames = {
  SET_ALERT_VISIBLE: 'SET_ALERT_VISIBLE',
  SET_ALERT: 'SET_ALERT'
}

// mutations
const mutations: MutationTree<IAlertModuleState> = {
  [AlertMutationsNames.SET_ALERT_VISIBLE]: function(state: IAlertModuleState, value: boolean) {
    state.visible = value
  },
  [AlertMutationsNames.SET_ALERT](state: IAlertModuleState, value: Alert) {
    state.alert = value
  }
}

// actions
const actions: ActionTree<IAlertModuleState, IStoreRootState> = {
  [Actions.ALERT]: async function({ commit }, alert: Alert) {
    commit(AlertMutationsNames.SET_ALERT, alert)
    commit(AlertMutationsNames.SET_ALERT_VISIBLE, true)
  },
  [Actions.ALERT_TOGGLE_VISIBLE]: function({ commit }, value: boolean) {
    commit(AlertMutationsNames.SET_ALERT_VISIBLE, value)
  }
}

const alertModule: Module<IAlertModuleState, IStoreRootState> = {
  state,
  getters,
  actions,
  mutations
}

export default alertModule
